var map = {
	"./icon-climbs.svg": "99e4",
	"./icon-content-improvements.svg": "dfac",
	"./icon-ctr-boost.svg": "976da",
	"./icon-drops.svg": "f28e",
	"./icon-featured-snippet.svg": "a834",
	"./icon-high-bounce-rate.svg": "8771",
	"./icon-high-impressions-low-ctr.svg": "f4b7",
	"./icon-key.svg": "4f1c",
	"./icon-keyword-cannibalisation.svg": "81bf",
	"./icon-long-tail-keywords.svg": "d2f3",
	"./icon-low-hanging-fruit.svg": "19a6",
	"./icon-low-traffic-high-impressions.svg": "fa90",
	"./icon-questions-not-ranking.svg": "fc75",
	"./icon-video.svg": "a44f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85b7";